import fetch from 'isomorphic-fetch';
import { handleFetchedErrors, headers } from '../utils';

function fetchData(url, options, callback, error) {
	return fetch(url, options)
		.then(handleFetchedErrors)
		.then(response => response.json())
		.then(callback)
		.catch(error);
}

export function get(url, callback, error){
	const options = Object.assign({ method: 'GET' }, headers);

	return fetchData(url, options, callback, error);
}

export function post(url, data, callback, error){
	const options = Object.assign({ method: 'POST', body: JSON.stringify( data ) }, headers);

	return fetchData(url, options, callback, error);
}



// WEBPACK FOOTER //
// ./react-app-src/shared/services/FetchService.js